import { Form, Input, Button, Select, message, Card, Typography, theme,Alert, Space } from "antd";
import { SendOutlined, MessageOutlined, BugOutlined, BulbOutlined, CommentOutlined } from '@ant-design/icons';
import axios from "axios";
import { getBackendUrl } from "../../utils/env";
import React, { useState } from "react";

const { Title, Text, Paragraph } = Typography;

export default function FeedbackForm() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const user_id = localStorage.getItem("user_id");

  const { token } = theme.useToken();

  const onFinish = (values) => {
    setLoading(true);
    const payload = { ...values, user_id };

    axios
      .post(`${getBackendUrl()}/api/feedback.php`, payload, {
        headers: { "Content-Type": "application/json" },
      })
      .then(() => {
        message.success("¡Gracias por tu comentario!");
        form.resetFields();
      })
      .catch((error) => {
        console.error("Error al enviar comentario:", error);
        message.error("No se pudo enviar el comentario.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div style={{ padding: 'clamp(16px, 4vw, 32px)', backgroundColor: token.colorBgLayout, minHeight: '80vh' }}>
      <Card
        style={{
          maxWidth: 600,
          margin: "0 auto",
          borderRadius: 24,
          boxShadow: token.boxShadowSecondary,
          border: `1px solid ${token.colorBorderSecondary}`,
        }}
        styles={{ body: { padding: 'clamp(24px, 5vw, 40px)' } }}
      >
        {/* Cabecera decorativa */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ 
            fontSize: 40, 
            color: token.colorPrimary, 
            marginBottom: 16,
            background: `${token.colorPrimary}15`,
            display: 'inline-flex',
            padding: 20,
            borderRadius: '50%'
          }}>
            <MessageOutlined />
          </div>
          <Title level={2} style={{ margin: 0 }}>¡Queremos escucharte!</Title>
          <Paragraph type="secondary" style={{ marginTop: 8 }}>
            Tu opinión nos ayuda a mejorar la experiencia de toda la comunidad.
          </Paragraph>
        </div>

        <Form layout="vertical" form={form} onFinish={onFinish} requiredMark={false}>
          {/* Selector de tipo con iconos */}
          <Form.Item
            name="type"
            label={<Text strong>¿Qué quieres compartir?</Text>}
            initialValue="suggestion"
            rules={[{ required: true }]}
          >
            <Select size="large" style={{ width: '100%' }}>
              <Select.Option value="bug">
                <Space><BugOutlined style={{ color: token.colorError }} /> Error o Problema</Space>
              </Select.Option>
              <Select.Option value="suggestion">
                <Space><BulbOutlined style={{ color: token.colorWarning }} /> Sugerencia</Space>
              </Select.Option>
              <Select.Option value="other">
                <Space><CommentOutlined style={{ color: token.colorInfo }} /> Comentario u Otro</Space>
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="title"
            label={<Text strong>Asunto</Text>}
            rules={[{ required: true, message: "Por favor, cuéntanos brevemente de qué trata." }]}
          >
            <Input 
              placeholder="Ej. No pude canjear mi premio" 
              size="large" 
              style={{ borderRadius: 8 }}
            />
          </Form.Item>

          <Form.Item
            name="message"
            label={<Text strong>Mensaje detallado</Text>}
            rules={[{ required: true, message: "Danos un poco más de detalle." }]}
          >
            <Input.TextArea
              rows={5}
              placeholder="Escribe aquí tus comentarios, quejas o ideas..."
              style={{ borderRadius: 12, padding: 12 }}
            />
          </Form.Item>

          <div style={{ marginBottom: 24 }}>
            <Alert 
              message="Tu mensaje será revisado por el equipo de administración." 
              type="info" 
              showIcon 
              style={{ borderRadius: 8, fontSize: 13 }}
            />
          </div>

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            icon={<SendOutlined />}
            size="large"
            block
            style={{
              height: 52,
              borderRadius: 12,
              fontWeight: 700,
              fontSize: 16,
              boxShadow: `0 4px 12px ${token.colorPrimary}40`
            }}
          >
            Enviar Comentario
          </Button>
        </Form>
      </Card>
    </div>
  );
}
